// Rosepod Mock Data

export const heroData = {
  headline: "Create Leading Podcasts With Impact",
  subheadline: "Strategy, storytelling, and production — all under one roof.",
  primaryCta: "Start Your Podcast",
  secondaryCta: "See How It Works"
};

export const stepsData = [
  { id: 1, title: "Plan", description: "Strategy & concept development" },
  { id: 2, title: "Produce", description: "Professional recording & editing" },
  { id: 3, title: "Publish", description: "Global distribution & growth" }
];

export const statsData = [
  { number: "500M+", label: "Weekly podcast listeners globally" },
  { number: "4.2M", label: "Active podcasts worldwide" },
  { number: "73%", label: "Growth in podcast ad revenue" },
  { number: "2X", label: "Higher engagement than other media" }
];

export const servicesData = [
  { id: 1, title: "Ideation", description: "Transform raw ideas into compelling podcast concepts that resonate with your target audience.", icon: "Lightbulb" },
  { id: 2, title: "IP Creation", description: "Build a unique brand identity including name, artwork, and sonic branding.", icon: "Sparkles" },
  { id: 3, title: "Content Planning", description: "Strategic episode planning, content calendars, and story arcs that keep listeners hooked.", icon: "Calendar" },
  { id: 4, title: "Guest Planning", description: "Curate and book high-profile guests that elevate your show's credibility.", icon: "Users" },
  { id: 5, title: "Studio Selection", description: "Access premium recording studios or set up your perfect home studio.", icon: "Building" },
  { id: 6, title: "Production", description: "Professional recording with top-tier equipment and experienced engineers.", icon: "Mic" },
  { id: 7, title: "Post-production", description: "Expert editing, mixing, mastering, and sound design that makes you sound amazing.", icon: "Sliders" },
  { id: 8, title: "Distribution", description: "Launch on all major platforms with optimized metadata for maximum discoverability.", icon: "Share2" }
];

export const processData = [
  { id: 1, title: "Discovery & Strategy", description: "We dive deep into your vision, audience, and goals to create a winning podcast strategy." },
  { id: 2, title: "IP & Format", description: "Develop your unique show format, branding, and intellectual property." },
  { id: 3, title: "Content & Guests", description: "Plan your content calendar and curate the perfect guest lineup." },
  { id: 4, title: "Record & Produce", description: "Capture your voice in our professional studios with expert guidance." },
  { id: 5, title: "Edit & Polish", description: "Transform raw recordings into polished, engaging episodes." },
  { id: 6, title: "Launch & Grow", description: "Strategic launch and ongoing growth optimization across platforms." }
];

export const studioFeatures = [
  { title: "4K Video", description: "Cinema-quality cameras for video podcasts" },
  { title: "Pro Audio", description: "Industry-leading microphones & acoustics" },
  { title: "Studio Lighting", description: "Professional LED setups for perfect shots" },
  { title: "Custom Sets", description: "Branded backdrops & set design" }
];

export const portfolioData = [
  { id: 1, title: "Two Boys One Cup", host: "Rosepod Original", category: "Comedy", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/47q017eg_2%20Boys%201%20cup%20%282%29.png", link: "https://www.youtube.com/playlist?list=PLu29j_MLXFXg8aZSLp2kJGW4ouTCYauRd" },
  { id: 2, title: "Cupgraded", host: "Rosepod Original", category: "Lifestyle", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/gbv37uaz_Cupgraded%20%281%29.png" },
  { id: 3, title: "The Filmy Hustle", host: "Rosepod Original", category: "Entertainment", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/env6kqaa_Filmy%20hustle.png", link: "https://www.youtube.com/playlist?list=PLu29j_MLXFXhsCjFLRGC41JyocIG2TW63" },
  { id: 4, title: "The Happy Pawdcast", host: "Rosepod Original", category: "Pets & Animals", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/czsb3tlv_Happy%20pawdcast%2001.png", link: "https://www.youtube.com/playlist?list=PLu29j_MLXFXhOLFYFwFjqI8cBkmAo8DaJ" },
  { id: 5, title: "Next In Marketing", host: "Rosepod Original", category: "Business", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/yt2721j8_Next%20In%20Marketing.png", link: "https://www.youtube.com/playlist?list=PLu29j_MLXFXjMlwHPnE0S6jRwYxdH364M" },
  { id: 6, title: "Evolve with Gita Hariani", host: "Rosepod Original", category: "Wellness", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/ftnaer1r_Evolve%20with%20gita.png", link: "https://www.youtube.com/playlist?list=PLu29j_MLXFXjYol2V971KWjU_rpPSvLwI" },
  { id: 7, title: "KalArt Shabd", host: "Rosepod Original", category: "Spoken Word", image: "https://customer-assets.emergentagent.com/job_podcast-launch-1/artifacts/q25whz6p_KalArt.png", link: "https://www.youtube.com/playlist?list=PLu29j_MLXFXjKF-_WsCdykd28Q9uV3t6x" },
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Mitchell",
    role: "Host, The Creative Hour",
    quote: "Rosepod transformed my idea into a top-charting podcast. Their team is incredible!",
    rating: 5,
    avatar: "SM"
  },
  {
    id: 2,
    name: "James Chen",
    role: "Founder, TechVentures",
    quote: "Professional, creative, and results-driven. Our branded podcast exceeded all expectations.",
    rating: 5,
    avatar: "JC"
  },
  {
    id: 3,
    name: "Dr. Emily Ross",
    role: "Author & Speaker",
    quote: "From zero experience to 100K downloads. Rosepod made podcasting effortless for me.",
    rating: 5,
    avatar: "ER"
  }
];

export const studioImages = [
  "https://images.unsplash.com/photo-1668606143651-15faee151b8e?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1589903308904-1010c2294adc?w=800&h=600&fit=crop",
  "https://images.unsplash.com/photo-1590602847861-f357a9332bbc?w=800&h=600&fit=crop"
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Work", href: "#work" },
  { label: "Process", href: "#process" },
  { label: "Studio", href: "#studio" },
  { label: "About", href: "/about", isPage: true },
  { label: "Media", href: "/media", isPage: true },
  { label: "Gallery", href: "/gallery", isPage: true },
  { label: "Contact", href: "#contact" }
];

export const socialLinks = [
  { name: "Instagram", url: "https://www.instagram.com/rosepodindia/?hl=en" },
  { name: "YouTube", url: "https://www.youtube.com/@rosepod" }
];

export const contactInfo = {
  email: "business@roseaudiovisuals.com"
};

export const platformBadges = [
  { name: "Spotify", icon: "spotify" },
  { name: "Apple Podcasts", icon: "apple" },
  { name: "YouTube", icon: "youtube" }
];
